import { Box, HStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import PromptInputTag from "./PromptInputTag";
import PromptTestingAnswer from "./PromptTestingAnswer";
import PropmtList from "./PropmtList";
import { useSelector } from "react-redux";

function PromptTest() {
  const savePromptList = useSelector(
    (state) => state.promptTesting.savePromptData
  );

  const [formData, setFormData] = useState({
    // id: v4(),
    prompt: [],
    system_message: [],
    model: "",
    selected_model: "",
    tokens: 1024,
    temperature: 0.3,
    top_p: 0.9,
    json: false,
  });

  useEffect(() => {
    setFormData({
      // id: v4(),
      prompt: [],
      system_message: [],
      model: "",
      selected_model: "",
      tokens: 1024,
      temperature: 0.3,
      top_p: 0.9,
      json: false,
    });
  }, [savePromptList]);

  return (
    <HStack gap={0} h={"95vh"}>
      <PropmtList />
      <PromptInputTag setFormData={setFormData} formData={formData} />
      <PromptTestingAnswer setFormData={setFormData} formData={formData} />
    </HStack>
  );
}

export default PromptTest;
